import PropTypes from 'prop-types';

export const propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number,
  dataId: PropTypes.string
};

export const defaultProps = {
  size: 40
};

export const propDescriptions = {};
